module.exports = __webpack_public_path__ + "img/chuangsai_26.d355ba19.jpg";